import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { GetSessionError } from '~/backend/connector-api/connector-components';
import ImageAndStructureSetDisplay from '~/components/InputDataPreview/ImageAndStructureSetDisplay';
import { primaryImageState } from '~/state/atoms/image/imageAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';
import DoseModelSelection from './DoseModelSelection';

type DosePredictionModalProps = {
    availableModels: PredictionModel[];
    isLoadingModels: boolean;
    isLoadingSession?: boolean;
    isSubmitting?: boolean;
    error?: Error | GetSessionError | null;
    showPseudonymization: boolean;
    onSubmit: (modelName: string) => void;
};

export default function DosePredictionModal({
    availableModels,
    onSubmit,
    isLoadingModels,
    isLoadingSession,
    isSubmitting,
    error,
    showPseudonymization,
}: DosePredictionModalProps) {
    const primaryImage = useRecoilValue(primaryImageState);
    const currentStructureSet = useRecoilValue(currentStructureSetState);

    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Box>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    <FormattedMessage id="dosePlus" />
                </Typography>
                <Typography variant="body2">
                    <FormattedMessage id="dosePredictionDescription" />
                </Typography>
            </Box>
            <Box display="grid" gap={2}>
                <ImageAndStructureSetDisplay
                    image={primaryImage}
                    structureSet={currentStructureSet}
                    isLoading={isLoadingSession}
                    error={error}
                />
                <DoseModelSelection
                    availableModels={availableModels}
                    onSubmit={onSubmit}
                    isLoadingSession={isLoadingSession}
                    isSubmitting={isSubmitting}
                    isLoadingModels={isLoadingModels}
                    showPseudonymization={showPseudonymization}
                />
            </Box>
        </Box>
    );
}
